import axios, { AxiosError } from 'axios';

import { GetCityzensProfileError } from 'services/account';

import { useRedirect } from '../use-redirect';
import { useToast } from '../use-toast';

export type ApiError = {
	errorMessage: string;
	propertyName: string;
}[];

type ErrorInstance =
	| AxiosError
	| AxiosError<ApiError>
	| Error
	| GetCityzensProfileError
	| string
	| any;

export const useErrorHandler = () => {
	const toast = useToast();
	const redirect = useRedirect();

	const process = (
		error: ErrorInstance,
		isRedirect = true,
		code?: number
	) => {
		if (
			error.message !== 'axios request cancelled' &&
			error !== 'axios request cancelled'
		) {
			const errorCode = axios.isAxiosError(error)
				? error.response?.status
				: code;
			isRedirect && redirect({ code: errorCode });

			toast.error({ content: error });
		} else {
			toast.error({ content: 'Something went wrong' });
		}
	};

	return { process };
};
